import { CSSProperties } from 'react'
import {
   hexToRgba,
   orbPalette,
} from '@forwardflow/features/campaign-flow/utils/orb'

/**
 * The voice orb from Campaign Studio (itself a port of the dashboard's
 * AIOrb.vue): conic energy ring, glass core with mesh blooms, sheen,
 * reflection, distortion and a boundary ring. One palette per voice hue.
 * `talking` speeds up the core while a voice is speaking.
 */
export const AiOrb = ({
   hue,
   size = 96,
   animated = true,
   talking = false,
   className = '',
}: {
   hue: number
   size?: number
   animated?: boolean
   talking?: boolean
   className?: string
}) => {
   const { primary: p, secondary: s, accent: a } = orbPalette(hue)
   const vars = {
      '--orb-size': `${size}px`,
      '--p-27': hexToRgba(p, 0.27),
      '--s-67': hexToRgba(s, 0.67),
      '--a-67': hexToRgba(a, 0.67),
      '--p-67': hexToRgba(p, 0.67),
      '--p-53': hexToRgba(p, 0.53),
      '--s-53': hexToRgba(s, 0.53),
      '--a-53': hexToRgba(a, 0.53),
      '--p-15': hexToRgba(p, 0.15),
      '--s-12': hexToRgba(s, 0.12),
      '--s-20': hexToRgba(s, 0.2),
      '--s-40': hexToRgba(s, 0.4),
      '--p-18': hexToRgba(p, 0.18),
      '--a-10': hexToRgba(a, 0.1),
      '--p-08': hexToRgba(p, 0.08),
      '--p-10': hexToRgba(p, 0.1),
      '--s-08': hexToRgba(s, 0.08),
      '--p-80': hexToRgba(p, 0.8),
      '--s-70': hexToRgba(s, 0.7),
      '--a-60': hexToRgba(a, 0.6),
      '--p-40': hexToRgba(p, 0.4),
      '--s-30': hexToRgba(s, 0.3),
      '--a-40': hexToRgba(a, 0.4),
      '--p-30': hexToRgba(p, 0.3),
      '--p-20': hexToRgba(p, 0.2),
      '--s-15': hexToRgba(s, 0.15),
      '--a-20': hexToRgba(a, 0.2),
   } as CSSProperties
   return (
      <div
         className={`ai-orb${animated ? ' is-animated' : ''}${animated && talking ? ' is-talking' : ''} ${className}`}
         style={vars}
         role="img"
         aria-label="Voice"
      >
         <div className="orb-ring" />
         <div className="orb-core-wrap">
            <div className="orb-core">
               <div className="orb-particles" />
               <div className="orb-conic" />
               <div className="orb-sheen" />
               <div className="orb-reflection" />
               <div className="orb-distortion" />
            </div>
            <div className="orb-boundary" />
         </div>
      </div>
   )
}
